<div class="login_sheet">
  <img src="../../../../assets/images/Logo_Orange_colorless.png" class="logo_login" alt="">
  <form action="" method="post" *ngIf="remainingTime == null">
    <div *ngIf="risky$ | async as risky">
      <div *ngIf="errMsg$ | async as errMsg">
        <div class="notification error" *ngIf="risky">
          {{ errMsg.message | translate}}
        </div>
      </div>
    </div>

    <div class="form_group">
      <input type="text" #email class="with_email_icon" placeholder="{{'Email' | translate}}">
    </div>
    <div class="form_group">
      <input type="password" #password class="with_lock_icon" placeholder="{{'Password' | translate}}">
    </div>
    <div class="form_group">
      <input (click)="onSubmit(email.value,password.value)" [disabled]="loading"
        [value]="loading? 'loading...' : 'ENTER'" type="submit">
    </div>
    <div class="form_group forgot_pass">
      <a [routerLink]="['/auth/forgot-password']">*{{'forgot password' | translate}}</a>
    </div>
    <div *ngIf="risky$ | async as risky">
      <div *ngIf="errMsg$ | async as errMsg">
        <div class="form_group forgot_pass" *ngIf="risky">
          <a [routerLink]="['/auth/change-password']">*{{'change password' | translate}}</a>
        </div>
      </div>
    </div> 
  </form>
  
  <div class="form_group" *ngIf="remainingTime != null">
    <p class="warning">{{lockMessage}}</p>
    <p class="timer">{{remainingTime}}</p>
  </div>
  <div class="powered_by">{{'Copyright' | translate}} d.light {{currentYear}}</div>
</div>
